import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';
Vue.use(VueI18n);
const messages = {};
const requireLang = require.context('@/lang', true, /.*(?<!\.\/)index\.js/);
requireLang.keys().forEach((langPath) => {
	let lang = langPath.replace(/\.\/|\/index\.js/g, '');
	messages[lang] = {
		...requireLang(langPath).default,
	};
});
let locale = 'tw';
const i18n = new VueI18n({
	locale: locale,
	messages,
});

export default i18n;
